export const config = {
  title: 'Elias Velasques Landscaping | Landscaping Services in Little River, SC',
  meta: {
    description:
      'Elias Velasques Landscaping offers professional landscaping services in Little River, SC. Specializing in design, installation, and maintenance, we create stunning outdoor spaces tailored to your needs.',
    keywords: [
      'Landscaping Services Little River SC',
      'Pavers Installation',
      'Brick Installation',
      'Irrigation Systems',
      'Palm Care',
      'Elias Velasques Landscaping',
      'MyBizSolutions LLC',
      'BizSolutions LLC'
    ],
    author: 'Elias Velasques Landscaping',
    canonicalUrl: 'https://eliasvelasqueslandscaping.com/',
  },
  sections: {
    header: {
      businessName: 'Elias Velasques Landscaping',
    },
    sectionB: {
      heroTitle: 'Elias Velasques Landscaping',
      heroSubtitle: 'Transforming Your Outdoor Spaces with Professional Landscaping Services',
      learnAboutText: 'Explore Services',
      phoneNumber: '8435347662',
      phoneLabel: '(843) 534-7662',
      heroBackgroundImage:
        'https://media.istockphoto.com/id/1418465051/photo/aerial-view-of-modern-backyard-with-vegetable-garden.jpg?s=612x612&w=0&k=20&c=a_3DxsLc_F_OS4M3CtUWia2mFNgqErFCFYBm9qiYs4k=',
      cardData: [
        {
          title: 'Creative Landscape Design',
          description:
            'We design outdoor spaces that reflect your style and enhance the beauty of your property.',
        },
        {
          title: 'Pavers and Brick Installation',
          description:
            'Expertly crafted pathways and patios for durability and elegance.',
        },
        {
          title: 'Comprehensive Lawn Care',
          description:
            'From mowing to mulching, we provide all the care your lawn needs to thrive.',
        },
      ],
      description:
        'Elias Velasques Landscaping provides expert landscaping services, including design, installation, and maintenance. Our commitment to quality ensures your outdoor spaces are beautiful and functional.',
    },
    sectionC: {
      servicesTitle: 'Our Services',
      servicesDescription:
        'We offer a range of professional landscaping services tailored to meet your needs. From stunning designs to maintenance and specialized services, we ensure your outdoor spaces look their best year-round.',
      cards: [
        {
          title: 'Landscaping Services',
          description:
            'We specialize in transforming outdoor spaces with our expert landscaping services, including design and installation.',
          imageSrc:
            'https://firebasestorage.googleapis.com/v0/b/genius-tech-crm.appspot.com/o/Stock%2FLandscaping%2FHardscape%20(1)_1.jpg?alt=media&token=e300ca38-1470-4f9b-b429-f35d89931bd3',
          imageAlt: 'Landscaping Services',
        },
        {
          title: 'Pavers Installation',
          description:
            'Create beautiful, durable pathways and patios with our pavers installation service.',
          imageSrc:
            'https://firebasestorage.googleapis.com/v0/b/genius-tech-crm.appspot.com/o/Stock%2FConcrete%2Fstamped%20concrete.jpg?alt=media&token=c1cb9a81-6b9d-4ad3-8137-4792a1318650',
          imageAlt: 'Pavers Installation',
        },
        {
          title: 'Brick Installation',
          description:
            'Enhance your property with expertly crafted brick installations for walkways and retaining walls.',
          imageSrc:
            'https://firebasestorage.googleapis.com/v0/b/genius-tech-crm.appspot.com/o/Stock%2FConcrete%2FBrick%20Wall%20(2).jpg?alt=media&token=30a02a81-60eb-406c-83f5-48b6fff727eb',
          imageAlt: 'Brick Installation',
        },
      ],
      otherServicesTitle: 'Other Services',
      otherServicesList: [
        'Retaining Wall Construction',
        'Patio Construction',
        'Irrigation System Installation',
        'Palm Care',
        'Bush Trimming',
        'Tree Cutting',
        'Mulching Services',
        'Drain Cleaning',
        'Pressure Washing',
        'Painting Services',
        'Concrete Services',
        'Wood Fencing',
      ],
    },
    sectionD: {
      aboutTitle: 'About Us',
      aboutImage: {
        src: 'https://firebasestorage.googleapis.com/v0/b/genius-tech-crm.appspot.com/o/galleryClientes%2FbMTiSq2L6KeJWhSvsEQX%2FlogosCliente%2Fwhite_0.webp?alt=media&token=79ea1333-2faa-4751-a5be-3325a4402ea7',
        alt: 'Elias Velasques Landscaping Team',
      },
      aboutText: [
        'With 15 years of experience in landscaping, Elias Velasques Landscaping is dedicated to transforming outdoor spaces into beautiful, functional areas. We pride ourselves on exceptional service and a commitment to quality.',
        'Our team provides personalized landscaping services, ensuring every project reflects our clients’ vision and needs. From design to maintenance, we bring your dream outdoor spaces to life.',
      ],
    },
    sectionE: {
      profileImage:
        'https://firebasestorage.googleapis.com/v0/b/genius-tech-crm.appspot.com/o/galleryClientes%2FbMTiSq2L6KeJWhSvsEQX%2FlogosCliente%2Fwhite_0.webp?alt=media&token=79ea1333-2faa-4751-a5be-3325a4402ea7',
      profileAlt: 'Elias Velasques Landscaping Logo',
      businessName: 'Elias Velasques Landscaping',
      contact: {
        phone: '8435347662',
        phoneLabel: '(843) 534-7662',
        email: 'eliasvelasques@icloud.com',
        website: 'https://eliasvelasqueslandscaping.com/',
        address: 'Little River, SC',
      },
      socialMedia: {
        facebook: 'https://www.facebook.com/eliasvelasqueslandscaping/',
        twitter: 'https://x.com/elias_vela10736',
        tiktok: 'https://www.tiktok.com/@elias.velasques.l',
        instagram: 'https://www.instagram.com/eliasvelasqueslandscaping/',
      },
    },
    sectionF: {
      address: 'Little River, SC',
      googleMapsEmbedUrl:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3068.5760110136727!2d-78.63521!3d33.87091!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzPCsDUyJzE1LjciTiA3OMKwMzgnMTEuNCJX!5e0!3m2!1sen!2sus!4v1614123456789',
    },
  },
};

export default config;
